import React, { useEffect, useState } from "react";
import {
  Drawer,
  Select,
  Button,
  Form,
  Input,
  Typography,
  Divider,
  Spin,
  Descriptions,
  Alert,
} from "antd";
import RichTextEditor from "components/common/RichTextEditor";

const { Text } = Typography;

const TaskTransferDrawer = ({
  open,
  task,
  iterations = [],
  currentIterationId,
  onClose,
  onSubmit,
  loading = false,
  isBulk = false,
  selectedCount = 0,
}) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open && task) {
      form.setFieldsValue({
        targetIterationId: undefined,
        reason: "",
      });
    } else {
      form.resetFields();
    }
  }, [open, task, form]);

  const iterationOptions = iterations
    .filter((i) => String(i.id) !== String(currentIterationId))
    .map((i) => ({
      value: i.id,
      label: i.name || i.key || `Iteration ${i.id}`,
    }));

  const handleClose = () => {
    form.resetFields();
    onClose?.();
  };

  const handleFinish = async (values) => {
    try {
      setSubmitting(true);

      // await onSubmit({
      //   taskId: task.id,
      //   targetIterationId: values.targetIterationId,
      //   reason: values.reason,
      // });
      if (isBulk) {
        await onSubmit({
          targetIterationId: values.targetIterationId,
          reason: values.reason,
        });
      } else {
        if (!task?.id) return;

        await onSubmit({
          taskId: task?.id,
          targetIterationId: values.targetIterationId,
          reason: values.reason,
        });
      }

      onClose();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Drawer
      title={
        <span style={{ fontFamily: "Inter" }}>
          {isBulk ? "Move Multiple Tasks" : "Move Task to Another Iteration"}
        </span>
      }
      open={open}
      onClose={handleClose}
      size={520}
      zIndex={99999}
      destroyOnHidden
      footer={
        <div
          style={{
            textAlign: "left",
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <Button style={{ marginRight: 8 }} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={() => form.submit()}
            loading={submitting}
          >
            Transfer
          </Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        {/* bulk mode */}
        {isBulk ? (
          <Alert
            type="info"
            showIcon
            title={`${selectedCount} task(s) selected`}
            description="All selected tasks will be moved to the chosen iteration."
            style={{ marginBottom: 16, fontFamily:"Inter" }}
          />
        ) : (
          /* single mode */
          task && (
            <Descriptions
              size="small"
              column={1}
              bordered
              style={{
                marginBottom: 16,
                fontFamily: "Inter",
              }}
            >
              <Descriptions.Item label="Topic Name">
                {task?.title}
              </Descriptions.Item>

              <Descriptions.Item label="Assignee">
                {task?.assignee?.fullName || "-"}
              </Descriptions.Item>

              <Descriptions.Item label="Status">
                {task?.status || "-"}
              </Descriptions.Item>

              <Descriptions.Item label="Category">
                {task?.type || "-"}
              </Descriptions.Item>
            </Descriptions>
          )
        )}

        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <Form.Item
            name="targetIterationId"
            label="Target Iteration"
            rules={[
              {
                required: true,
                message: "Please select a target iteration",
              },
            ]}
          >
            <Select
              placeholder="Select iteration"
              options={iterationOptions}
              showSearch
            />
          </Form.Item>

          <Form.Item name="reason" label="Reason (optional)">
            <RichTextEditor
              placeholder="Why are you transferring this task?"
              height="180px"
            />
          </Form.Item>
        </Form>
      </Spin>
    </Drawer>
  );
};

export default TaskTransferDrawer;
